export default "392c523760c2680c2a98c78427d67db7.png";